'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { buildPortalUrl } from 'DesignData/lib/url';

const StatusBarChangelog = () => {
  return /*#__PURE__*/_jsxs(UILink, {
    className: "status-bar-header-button-long",
    href: buildPortalUrl('/developer-projects/$portalId'),
    target: "_blank",
    external: true,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "layers"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "DesignEditorsUI.statusBar.header.projects"
    })]
  });
};

export default StatusBarChangelog;